import { Link } from "react-router-dom";
import { trpc } from "@/trpc";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@satyrsmc/shared/components";
import { CalendarPlus } from "lucide-react";
import { AttendeeStatus, EventType } from "@satyrsmc/shared/lib/enums";
import { findUpcomingEvent } from "@/lib/eventUtils";

/** Members-area dashboard prompt: only renders when there's an upcoming
 * Badger event AND the current user hasn't already RSVP'd yes to it (a "no"
 * RSVP still shows it — only "going" hides it). Silent (renders nothing)
 * while loading or when neither condition holds — this is a nudge, not a
 * stat widget, so there's no "0 events" empty state to show. Not gated to
 * members-only: non-member contacts can also register for Badger, so any
 * authenticated user should see this. */
export function RegisterForBadgerCard() {
  const { data: events, isLoading: isLoadingList } = trpc.admin.events.list.useQuery({
    type: EventType.Badger,
  });

  const upcoming = findUpcomingEvent(events ?? []);

  const { data: rsvp, isLoading: isLoadingRsvp } = trpc.members.rsvps.getForEvent.useQuery(
    { eventId: upcoming?.id ?? "" },
    { enabled: !!upcoming },
  );

  if (isLoadingList || (upcoming && isLoadingRsvp)) return null;
  if (!upcoming) return null;
  if (rsvp?.status === AttendeeStatus.Yes) return null;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          Register for {upcoming.name}
        </CardTitle>
        <CalendarPlus className="size-4 text-muted-foreground" />
      </CardHeader>
      <CardContent className="flex flex-row items-center justify-between pb-2">
        <div className="flex items-center gap-3">
          <div>
            <p className="text-sm text-muted-foreground">You haven&rsquo;t signed up yet.</p>
          </div>
        </div>
        <Button asChild>
          <Link to={`/events/${upcoming.id}/register`}>Register</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
